import React from 'react';
import './Clients.css';
import prodege from '../assets/clients/prodege.png';
import partnerDogs from '../assets/clients/partnerDogs.png';
import propell from '../assets/clients/propell.png';
import stratagile from '../assets/clients/stratagile.png';
import aspermont from '../assets/clients/aspermont.png';
import clickray from '../assets/clients/clickray_logo.png';
import powerhouse from '../assets/clients/powerhouse.png';
import inovusMedical from '../assets/clients/inovus-medical.png';
import mPowerSolar from '../assets/clients/M-Power-Solar.png';
import edelweissRe from '../assets/clients/Edelweiss-Re.png';

const CLIENTS = [
  { name: 'Prodege', image: prodege },
  { name: 'Partner Dogs', image: partnerDogs },
  { name: 'Propell', image: propell },
  { name: 'Stratagile', image: stratagile },
  { name: 'Aspermont', image: aspermont },
  { name: 'Clickray', image: clickray },
  { name: 'Powerhouse', image: powerhouse },
  { name: 'Inovus Medical', image: inovusMedical },
  { name: 'M Power Solar', image: mPowerSolar },
  { name: 'Edelweissre Real Estate & Design', image: edelweissRe },
];

export default function Clients() {
  return (
    <section className="clients">
      <div className="clients-eyebrow" data-reveal>TRUSTED BY TEAMS AT</div>
      <div className="clients-marquee" data-reveal>
        <div className="clients-track">
          {[...CLIENTS, ...CLIENTS].map((client, index) => (
            <img
              src={client.image}
              key={index}
              alt={client.name}
              className="clients-logo"
              aria-hidden={index >= CLIENTS.length}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
